import { render, staticRenderFns } from "./DeleteConfirmBtn.vue?vue&type=template&id=f50d5a8e&scoped=true"
import script from "./DeleteConfirmBtn.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmBtn.vue?vue&type=script&lang=js"
import style0 from "./DeleteConfirmBtn.vue?vue&type=style&index=0&id=f50d5a8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50d5a8e",
  null
  
)

export default component.exports